import React, {Fragment} from "react";
import SweetAlertBase from "./SweetAlertBase";
import SVG from "react-inlinesvg";
import questionSVG from "../../../assets/svg/ils/ils-question.svg";
// import "../../../assets/sass/pages/scouting/reject-scouting-modal.scss";

class SA_RejectScouting extends SweetAlertBase {

    config = {
        showCancelButton: true,
        confirmButtonText: 'Yes, Reject',
        cancelButtonText: 'Don’t Reject',
    }

    setHtml = (data) => {
        return (
            <Fragment>
                <div className="reject-scouting-alert">
                    <SVG src={questionSVG}/>
                    <h2>Reject Scouting</h2>
                    <p>Are you sure you want to reject the scouting? You wont be able to accept it again</p>
                </div>
                <div className="reject-scouting-content">
                    <div className="player">
                        <img src={data.avatar}/>
                        <h2>{data.to.name}</h2>
                        <span>{data.to.role}</span>
                    </div>
                    <span>Invite From</span>
                    <div className="player">
                        <h2>{data.from.name}</h2>
                        <span>{data.from.role}</span>
                    </div>
                </div>
            </Fragment>
        )
    }

    type() {
      return 'sm';
    }

    className() {
        return "reject-scouting";
    }

    confirmButtonClasses() {
        return "btn secondary btn-md btn-block";
    }

    cancelButtonClasses() {
        return "btn btn-primary btn-md btn-block";
    }
};

export default SA_RejectScouting;